import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { useSnackbarContext } from '../../context/SnackbarProvider/SnackbarProvider'

const createCampaign = async campaignData => {
  console.log('campaignData', campaignData)
  const url = `${baseUrl}/aws/campaigns`

  //////////////////////////////////////////////////
  console.log('NEW CAMPAIGN DATA TO SUBMIT[MUTATION]: ', campaignData)
  const response = await axios.post(url, campaignData, {})
  return response.data // This allows the response data to be accessed in onSuccess
}

export const useCreateCampaign = () => {
  const { showSnackbar } = useSnackbarContext()
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: createCampaign,
    onMutate: async newCampaign => {
      // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
      await queryClient.cancelQueries({ queryKey: ['campaigns'] })

      // Snapshot the previous value
      const previousCampaigns = queryClient.getQueryData(['campaigns'])
      console.log(
        '[useCreateCampaign] previousCampaigns: ',
        previousCampaigns ? previousCampaigns : 'No Previous Strategies Cached'
      )
      // Optimistically update to the new value

      return { previousCampaigns }
    },
    onError: (err, newCampaign, context) => {
      // Roll back the optimistic update
      queryClient.setQueryData(['campaigns'], context.previousCampaigns)
      console.error('Mutation Error:', err)
      showSnackbar((err as any).response?.data?.message || err.message, 'error')
    },
    onSuccess: data => {
      // console.log('[useCreateCampaign] onSuccess data: ', data)
      // Invalidate and refetch or update query data

      queryClient.setQueryData(['campaigns'], (old: any) =>
        old ? [...old, { ...data, id: data.campaign_uuid }] : [{ ...data, id: data.campaign_uuid }]
      )
      showSnackbar('Campaign created successfully', 'success')
    },

    onSettled: () => {
      // Always refetch after error or success:
    },
  })

  return mutation
}
